// extracted by mini-css-extract-plugin
export var typingIndicator = "_mh-0";